module.exports = __webpack_public_path__ + "img/audit_tool.ca62a40.png";